import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IUser, IUserJWT, IUserLoginResponse, IUserForgotResponse, IUserResetResponse } from '../models/user.model';
import { IUserLogin } from '../models/user.login.interface';
import { IUserForgot } from '../models/user.login.interface';
import { IUserReset } from '../models/user.login.interface';
import { jwtDecode } from "jwt-decode";


@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private headers: any;
  private userSubject: BehaviorSubject<IUser | null>;
  public user: Observable<IUser | null>;

  constructor(
    private router: Router,
    private http: HttpClient
  ) {
    this.userSubject = new BehaviorSubject(JSON.parse(localStorage.getItem('user')!));
    this.user = this.userSubject.asObservable();
    this.headers = new HttpHeaders();
    this.headers = this.headers.set('Content-Type', 'application/json')
  }

  public get userValue() {
    return this.userSubject.value;
  }

  public get currentUser() {
    const user: IUser = JSON.parse(localStorage.getItem('user')!);
    return user;
  }

  login(user: IUserLogin) {
    return this.http.post<IUserLoginResponse>(`${environment.apiUrl}auth/jwt`, { email: user.email, password: user.password })
      .pipe(map(response => {
        const user = this.setAccount(response.access_token);
        this.userSubject.next(user);
        return response.access_token;
      }));
  }

  forgot(user: IUserForgot) {
    return this.http.post<IUserForgotResponse>(`${environment.apiUrl}auth/send-recover-password`, { email: user.email });
  }

  reset(user: IUserReset, token: string) {
    const headers = {
      'Authorization': `Bearer ${token}`
    };
    return this.http.post<IUserResetResponse>(
      `${environment.apiUrl}auth/change-password`,
      { password: user.password, password_confirm: user.password_confirm },
      { headers }
    );
  }

  verifyMagicLink(token: string) {
    return this.http.get(`${environment.apiUrl}auth/verify-recover-password/${token}`);
  }

  setAccount(access_token: string) {
    const decodedUser: IUserJWT = jwtDecode(access_token);
    const user: IUser = {
      email: decodedUser.email,
      access_token: access_token,
      identity: decodedUser.identity,
      username: decodedUser.username,
      groups: decodedUser.groups,
      type: decodedUser.type,
      imagePath: `${environment.publicUrl}${decodedUser.image_path}`,
      permissions: decodedUser.permissions
    };
    localStorage.setItem('user', JSON.stringify(user));
    return user;
  }

  forbidden() {
    this.router.navigate(['/']);
  }

  logout() {
    localStorage.removeItem('user');
    this.userSubject.next(null);
    this.router.navigate(['/auth/login']);
  }
}
